import styled from "@emotion/styled";
import { type CSSProperties } from "react";

import { FieldSelect, FormField } from "@skilitics/designer-ui-components";

export const BorderStylePicker = () => {
  return (
    <FormField name="borderStyle">
      <FieldSelect options={borderStyleOptions} />
    </FormField>
  );
};

const BorderStyleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 100%;
  padding: 0 4px;
  text-transform: capitalize;
`;

const BorderStyle = styled.div`
  height: 0;
  width: 30px;
  border-top-width: 3px;
  border-top-color: ${({ theme }) => theme.generalTextIcon};
`;

const BorderStyleDemo = ({ borderStyle }: { borderStyle: CSSProperties["borderTopStyle"] }) => (
  <BorderStyleWrapper>
    <BorderStyle style={{ borderTopStyle: borderStyle }} />
    <span>{borderStyle}</span>
  </BorderStyleWrapper>
);

const selectableBorderStyles: CSSProperties["borderTopStyle"][] = [
  "solid",
  "dashed",
  "dotted",
  "double",
  "groove",
  "ridge",
];

const borderStyleOptions = selectableBorderStyles.map((borderStyle) => ({
  value: borderStyle as string,
  label: <BorderStyleDemo borderStyle={borderStyle} />,
}));
